import React from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { apiGet, apiPost, getHostApi, getHostUrl } from '../../store/apiWrapper';
import { Circles } from '../common/loadingComponent';
import NoDataComponent from '../common/noDataComponent';
import { PdfExportButton } from '../common/refButtons';

import './ratioBook.scss';

class RatioBookMethodology extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            isLoading: true
        };
    }

    componentDidMount() {
        this.getData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.year !== prevProps.year || this.props.language !== prevProps.language) {
            this.getData();
        }
    }

    getData() {
        this.setState({ isLoading: true });

        apiGet(getHostApi() + `/api/ratiobook/methodology?year=${this.props.year}`,
            null,
            (data) => this.setState({ data: data.data, isLoading: false }),
            () => this.setState({ isLoading: false }));
    }

    renderTitle() {
        return (
            <>
                <div className="ratioBookTitle">
                    <div className="print-hidden" style={{ visibility: "hidden" }}>
                        <PdfExportButton onClick={undefined} hideLabel oldIcon />
                    </div>
                    <span className="underlined-title-wrapper underlined-title-wrapper-margin-bottom print-hidden">
                        <h5 className="underlined-title rb-header">
                            {<Translate id="RatioBook.Methodology" options={{ renderInnerHtml: true }} />}
                            {` (${this.state.data.year})`}
                        </h5>
                    </span>
                    <div className="print-hidden">
                        <PdfExportButton onClick={() => this.exportToPdf(this.state.data.year)} hideLabel oldIcon />
                    </div>
                </div>
                <div className="bold screen-hidden" style={{ textAlign: 'center' }}>
                    <Translate id="RatioBook.SectionName" />: <Translate id="RatioBook.Methodology" /> {`(${this.state.data.year})`}
                </div>
            </>
        );
    }

    exportToPdf = (year) => {
        apiPost(getHostApi() + `/api/ratiobook/methodology/pdf-export`, { year: year }, null);
    }

    render() {
        const year = parseInt(this.props.year);
        if (isNaN(year))
            return (<NoDataComponent />);

        if (this.state.isLoading)
            return <Circles />

        if (!this.state.data || this.state.data.ratioBookMethodologyRows.length === 0)
            return (<NoDataComponent />);

        return (
            <React.Fragment>
                {this.renderTitle()}
                <div className="print-hidden">
                    {
                        [
                            { name: "sposob.pdf", translate: "RatioBook.Methodology.ModeProcessingTechnique" },
                            { name: "charak.pdf", translate: "RatioBook.Methodology.CharacterizationIndicatorsAndAlgorithm" },
                            { name: "defvym.pdf", translate: "RatioBook.Methodology.DefinitionDeterminationIndicators" }
                        ].map((document, i) => (
                            <>
                                <a key={`document-${i}`} className="link-internal" href={`${getHostUrl()}/files/ratiobook/${year}/${document.name}`} target="_blank">
                                    <Translate id={document.translate} /> ({year})
                                </a>
                                <br />
                            </>
                        ))}
                </div>
                <br />
                <table className="table table-report-section w-100">
                    <tbody>
                        <tr>
                            <th><Translate id="RatioBook.Methodology.Name" /></th>
                            <th><Translate id="RatioBook.Methodology.Unit" /></th>
                            <th><Translate id="RatioBook.Methodology.Description" /></th>
                        </tr>
                        {this.state.data.ratioBookMethodologyRows.map((r, i) => {
                            return <tr key={`methodology-row-${i}`}><td>{r.name}</td><td>{r.unit}</td><td>{r.description}</td></tr>
                        })}
                    </tbody>
                </table>
            </React.Fragment >
        )
    }
}

export default withLocalize(connect(
    state => ({ language: state.userContext.language }),
)(RatioBookMethodology));